export const environment = {
    production: false,
    apiUrl: 'http://localhost:3000',
    version: "urnae245vjr5eosd"
  };
  